"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeEmptyStrings = exports.getErrorFromCode = exports.splitErrors = exports.getPermissionsFromNumbers = exports.getEntityName = exports.replaceNullWithDash = exports.getLitigationNumberForSyncingSubscription = exports.findSyncedSubscriptions = exports.findManualSubscriptions = exports.shouldFollowPagination = exports.isPagedResponse = exports.isFirstPage = exports.toReadableDuration = exports.changeTimeFormat = exports.changeDateFormat = exports.getDateWithDash = void 0;

var _dateFns = require("date-fns");

var _lodash = require("lodash");

var _constants = require("./constants");

var getDateWithDash = function getDateWithDash(date) {
  return (0, _dateFns.lightFormat)(new Date(date), 'yyyy-MM-dd');
};

exports.getDateWithDash = getDateWithDash;

var changeDateFormat = function changeDateFormat(date) {
  return (0, _dateFns.lightFormat)(new Date(date), 'dd/MM/yyyy');
};

exports.changeDateFormat = changeDateFormat;

var changeTimeFormat = function changeTimeFormat(time) {
  var formatTime = time.split(':');
  return formatTime[0] + ':' + formatTime[1];
};

exports.changeTimeFormat = changeTimeFormat;

var parseDuration = function parseDuration(_duration) {
  var splittedDuration = _duration.split(' ');

  var splittedTime = [];
  var days = 0;

  if (splittedDuration.length === 1) {
    splittedTime = splittedDuration[0].split(':');
  } else {
    days = parseInt(splittedDuration[0], 10);
    splittedTime = splittedDuration[1].split(':');
  }

  var time = {
    hours: parseInt(splittedTime[0], 10),
    minutes: parseInt(splittedTime[1], 10),
    seconds: parseInt(splittedTime[2], 10)
  };
  return {
    days: days,
    hours: time.hours,
    minutes: time.minutes,
    seconds: time.seconds
  };
};

var toReadableDuration = function toReadableDuration(_duration) {
  var readableDuration = '';

  var _parseDuration = parseDuration(_duration),
      days = _parseDuration.days,
      hours = _parseDuration.hours,
      minutes = _parseDuration.minutes,
      seconds = _parseDuration.seconds;

  if (days && hours) {
    readableDuration = days + 'z';
  } else if (days && !hours) {
    readableDuration = days * 24 + 'h';
  }

  if (hours) {
    readableDuration = readableDuration + ' ' + hours + 'h';
  }

  if (minutes) {
    readableDuration = readableDuration + ' ' + minutes + 'm';
  }

  if (seconds) {
    readableDuration = readableDuration + ' ' + seconds + 's';
  }

  return readableDuration;
};

exports.toReadableDuration = toReadableDuration;

var isFirstPage = function isFirstPage(response) {
  return response.page === 1;
};

exports.isFirstPage = isFirstPage;

var isPagedResponse = function isPagedResponse(response) {
  return (0, _lodash.has)(response, 'page') && (0, _lodash.has)(response, 'pages');
};

exports.isPagedResponse = isPagedResponse;

var shouldFollowPagination = function shouldFollowPagination(response) {
  return isPagedResponse(response) && (0, _lodash.toNumber)(response.pages.next) && response.pages.next > response.page;
};

exports.shouldFollowPagination = shouldFollowPagination;

var findManualSubscriptions = function findManualSubscriptions(subscriptions) {
  var manualSub = (0, _lodash.some)(subscriptions, function (subscription) {
    return subscription.source === _constants.manualLitigationSource;
  });
  return !(0, _lodash.isEmpty)(subscriptions) && manualSub;
};

exports.findManualSubscriptions = findManualSubscriptions;

var findSyncedSubscriptions = function findSyncedSubscriptions(subscriptions) {
  var syncedSub = (0, _lodash.some)(subscriptions, function (subscription) {
    return subscription.litigation.sync_moment;
  });
  return !(0, _lodash.isEmpty)(subscriptions) && syncedSub;
};

exports.findSyncedSubscriptions = findSyncedSubscriptions;

var getLitigationNumberForSyncingSubscription = function getLitigationNumberForSyncingSubscription(subscriptions) {
  var syncingSub = (0, _lodash.find)(subscriptions, function (subscription) {
    return !subscription.litigation.sync_moment;
  });

  if (syncingSub) {
    return syncingSub.litigation.number;
  } else {
    return null;
  }
};

exports.getLitigationNumberForSyncingSubscription = getLitigationNumberForSyncingSubscription;

var replaceNullWithDash = function replaceNullWithDash(valueToCheck) {
  if ((0, _lodash.isNull)(valueToCheck) || (0, _lodash.isUndefined)(valueToCheck) || (0, _lodash.isEmpty)(valueToCheck)) {
    return '-';
  }

  return valueToCheck;
};

exports.replaceNullWithDash = replaceNullWithDash;

var getEntityName = function getEntityName(entity) {
  var entityName = '-';

  if (entity.type === _constants.EntityTypes.COMPANY) {
    if ((0, _lodash.has)(entity, 'name') && !(0, _lodash.isNull)(entity.name)) {
      entityName = entity.name;
    }
  } else if (entity.type === _constants.EntityTypes.PERSON) {
    if ((0, _lodash.has)(entity, 'first_name') && !(0, _lodash.isNull)(entity.first_name)) {
      entityName = entity.first_name;
    }

    if ((0, _lodash.has)(entity, 'last_name') && !(0, _lodash.isNull)(entity.last_name)) {
      if (entityName !== '-') {
        entityName = entityName + ' ' + entity.last_name;
      } else {
        entityName = entity.last_name;
      }
    }
  }

  return entityName;
};

exports.getEntityName = getEntityName;

var getPermissionsFromNumbers = function getPermissionsFromNumbers(permissions_array) {
  var permissions = {
    create: false,
    read: false,
    update: false,
    destroy: false
  };

  if ((0, _lodash.indexOf)(permissions_array, _constants.CRUDTypes.create.number) !== -1) {
    permissions.create = true;
  }

  if ((0, _lodash.indexOf)(permissions_array, _constants.CRUDTypes.read.number) !== -1) {
    permissions.read = true;
  }

  if ((0, _lodash.indexOf)(permissions_array, _constants.CRUDTypes.update.number) !== -1) {
    permissions.update = true;
  }

  if ((0, _lodash.indexOf)(permissions_array, _constants.CRUDTypes.destroy.number) !== -1) {
    permissions.destroy = true;
  }

  return permissions;
};

exports.getPermissionsFromNumbers = getPermissionsFromNumbers;

var splitErrors = function splitErrors(errors) {
  return {
    nonFieldErrors: errors.non_field_errors,
    fieldErrors: (0, _lodash.omit)(errors, 'non_field_errors')
  };
};

exports.splitErrors = splitErrors;

var getErrorFromCode = function getErrorFromCode(error, source) {
  var message = '';

  switch (error.code) {
    case 'email_not_verified':
      return 'Cont neactivat. Am retrimis chiar acum un link de activare pe adresa ta de email.';

    case 'does_not_exist':
      switch (source) {
        case 'ambassadorCodeUsages':
          message = 'Codul de ambasador introdus nu există. Te rugăm încearcă din nou cu un alt cod.';
          return message;

        case 'promoCodeUsages':
          message = 'Codul de reducere introdus nu există. Te rugăm încearcă din nou cu un alt cod.';
          return message;

        default:
          console.log('unknown source with code does_not_exist', error);
          return error.message;
      }

    case 'too_many_devices':
      return 'Ai depășit limita de dispozitive utilizate în cadrul abonamentului tău. Te rugăm să ne contactezi.';

    case 'password_too_common':
      return 'Parola este prea comună.';

    case 'password_entirely_numeric':
      return 'Parola nu poate conține doar cifre.';

    case 'password_too_short':
      return 'Parola trebuie să conțină cel puțin 8 caractere.';

    case 'invalid_phone_number':
      return 'Numărul de telefon introdus nu este valid.';

    case 'invalid':
      switch (source) {
        case 'login':
          message = 'Emailul sau parola sunt gresite! Te rugam incearca din nou.';
          return message;

        case 'resetPassword':
          message = 'Link-ul de resetare a parolei a expirat. ' + 'Te rugăm să refaci cererea de resetare a parolei.';
          return message;

        case 'subscription':
          message = 'În proiectele tale am mai găsit aceeași sursă de date deja adăugată. ' + 'Nu se poate atribui aceeași sursă de date de două ori.';
          return message;

        case 'entityProfiles':
          message = 'Adresa de email sau numărul de telefon sunt invalide.';
          return message;

        default:
          console.log('unknown source with code invalid', error);
          return error.message;
      }

    case 'incorrect':
      return 'Numele firmei sau numărul de înregistrare sunt incorecte.';

    case 'unique':
      switch (source) {
        case 'bpiSubscription':
          message = 'În contul tău am mai găsit o abonare de date cu acealși CUI. ' + 'CUI-ul trebuie sa fie unic pentru fiecare abonare BPI.';
          return message;

        case 'subscription':
          message = 'În proiectele tale am mai găsit aceeași sursă de date deja adăugată. ' + 'Nu se poate atribui aceeași sursă de date de două ori.';
          return message;

        case 'project':
          message = 'În proiectele tale am mai găsit un proiect cu exact același nume.';
          return message;

        case 'client':
          message = 'Un client cu același nume este deja creat.';
          return message;

        case 'contactPerson':
          message = 'Această adresă de email este deja asociată unei persoane de notificat.';
          return message;

        case 'partySubscription':
          message = 'În monitorizările tale de date am mai găsit aceeași sursă de date deja adăugată. ' + 'Nu se poate atribui aceeași sursă de date de două ori.';
          return message;

        case 'ambassadorCodeUsages':
          message = 'Se pare ca ai mai folosit un cod de ambasador în trecut. ' + 'Nu poți folosi mai multe coduri de ambasador.';
          return message;

        case 'groups':
          message = 'Există deja un grup cu același nume.';
          return message;

        case 'entityProfiles':
          message = 'Există deja un utilizator cu același email sau număr de telefon in compania ta.';
          return message;

        case 'projectPermissions':
          message = 'Acest utilizator are deja un rol în cadrul acestui proiect. ' + 'Un utilizator poate avea un singur rol în cadrul unui proiect.';
          return message;

        case 'clientPermissions':
          message = 'Acest utilizator are deja un rol în cadrul acestui client. ' + 'Un utilizator poate avea un singur rol în cadrul unui client.';
          return message;

        default:
          console.log('unknown source with code unique', error);
          return error.message;
      }

    case 'null':
      switch (source) {
        case 'entityProfiles':
          message = 'Toate câmpurile sunt obligatorii';
          return message;

        default:
          console.log('unknown source with code null', error);
          return error.message;
      }

    case 'blank':
      switch (source) {
        case 'login':
          message = 'Ambele câmpuri sunt obligatorii.';
          return message;

        default:
          console.log('unknown source with code blank', error);
          message = 'Câmpul este obligatoriu.';
          return message;
      }

    default:
      console.log('error from utils.js', error);
      return error.message;
  }
};

exports.getErrorFromCode = getErrorFromCode;

var removeEmptyStrings = function removeEmptyStrings(data) {
  if (data instanceof FormData) {
    return data;
  }

  if ((0, _lodash.isString)(data) && data === '') {
    return null;
  }

  if ((0, _lodash.isArray)(data)) {
    return (0, _lodash.map)(data, function (value) {
      return removeEmptyStrings(value);
    });
  }

  if ((0, _lodash.isObject)(data)) {
    return (0, _lodash.mapValues)(data, function (value) {
      return removeEmptyStrings(value);
    });
  }

  return data;
};

exports.removeEmptyStrings = removeEmptyStrings;